import { api } from "@/lib/api";

export const getCurrentUser = () => api.get("/auth/me", { withCredentials: true }).then(({ data }) => data);
export const exchangeGoogleSession = (sessionId) =>
  api.post("/auth/session", { session_id: sessionId }, { withCredentials: true, timeout: 20000 }).then(({ data }) => data);
export const logoutUser = () => api.post("/auth/logout", {}, { withCredentials: true });

export const startGoogleSignIn = () => {
  // REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
  const redirectUrl = window.location.origin + "/";
  window.location.assign(`https://auth.emergentagent.com/?redirect=${encodeURIComponent(redirectUrl)}`);
};